import { HttpResponse, ServiceClient } from '@johnlewispartnership/wtr-website-api-client';
import config from 'config';
import { logApiError, logApiInfo, LoggerRequestContext } from 'logger';
import getApiBaseUrl from 'utils/getApiBaseUrl';

type MembershipResponse = {
  type: string;
  number: string;
}[];

export const MY_WAITROSE_MEMBERSHIP = 'mywaitrose';

const membershipApiUrl = getApiBaseUrl(config.services.memberships.path);
const serviceName = 'membership';

class MembershipServiceClient extends ServiceClient {
  async getMemberships(
    authHeader: string,
    context?: LoggerRequestContext,
  ): Promise<{
    error?: { message: string };
    membership?: MembershipResponse;
  }> {
    const path = '/memberships';
    const response = await this.httpClient
      .get<MembershipResponse>(path, {
        headers: {
          Authorization: authHeader,
        },
      })
      .catch(e => ({ error: e }) as HttpResponse<MembershipResponse>);

    const membershipData = response.data;
    const membershipUrl = `${membershipApiUrl}${path}`;

    if (!membershipData || response.error) {
      logApiError(
        {
          payload: {
            service: serviceName,
            path,
            url: membershipUrl,
            message: `Error getting membership data: ${
              response.error?.message || 'Membership data missing from response'
            }`,
            duration: response.duration,
            httpStatus: `${response.status}`,
            httpStatusCode: response.status,
          },
        },
        context,
      );
    } else {
      logApiInfo(
        {
          payload: {
            service: serviceName,
            path,
            url: membershipUrl,
            message: 'Membership data loaded successfully',
            duration: response.duration,
            httpStatus: `${response.status}`,
            httpStatusCode: response.status,
          },
        },
        context,
      );
    }

    return {
      error: response.error ? { message: response.error.message } : undefined,
      membership: membershipData,
    };
  }
}

const membershipServiceClient = new MembershipServiceClient(membershipApiUrl);

export default membershipServiceClient;
